import { render, staticRenderFns } from "./fx-rates.vue?vue&type=template&id=146d7ebd&"
import script from "./fx-rates.vue?vue&type=script&lang=js&"
export * from "./fx-rates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports